import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-1.5">
        <li>
          <Link to="/" className="flex items-center gap-1 transition hover:text-primary-600">
            <i className="ri-home-4-line" />
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-300" />
            {item.to ? (
              <Link to={item.to} className="transition hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="line-clamp-1 max-w-[240px] text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}